const tableCells = (currency) => ({
    salaryCostOption: {
        isMulti: false,
        cells: [
            { label: `Средняя стоимость топлива, ${currency}/л`, propName: "averageFuelCost", disabled: false },
            {
                label: `ЗП и команд. водителям, ${currency}/км`,
                propName: "driverSalaryAndTravelAllowance",
                disabled: false,
            },
            { label: "Норма топлива (в среднем по парку), л/100 км", propName: "fuelRate", disabled: false },
            { label: `Средняя стоимость ремонта, ${currency}/км`, propName: "averageRepairCost", disabled: false },
            { label: `Средняя стоимость ОСАГО, ${currency}/год`, propName: "averageOsagoCost", disabled: false },
            {
                label: `Средняя стоимость страховки груза, ${currency}/год`,
                propName: "averageCargoInsuranceCost",
                disabled: false,
            },
            { label: "Итого расходы в месяц на ТО и ремонт парка", propName: "totalRepairCost", disabled: true },
            {
                label: `Итого лизинг, развитие, прочее (${currency}/авто)`,
                propName: "totalLeaseCostByCars",
                disabled: false,
            },
            {
                label: `Итого лизинг, развитие, прочее (${currency} по парку)`,
                propName: "totalLeaseCostByPark",
                disabled: true,
            },
        ],
    },
    indicators: {
        isMulti: true,
        cells: [
            { label: "Кол-во автомашин логиста", propName: "countOfCars", disabled: true },
            { label: "Пробег общий (км)", propName: "overallMileage", disabled: true },
            { label: "Пробег активный (км)", propName: "activeMileage", disabled: true },
            { label: "Пробег порожний (км)", propName: "emptyMileage", disabled: true },
            { label: "Порожний пробег %", propName: "emptyMileageBidRating", disabled: true },
            { label: `Выработка, ${currency}/км`, propName: "output", disabled: true },
            { label: `Топливо (${currency})`, propName: "fuelCost", disabled: true },
            { label: `ЗП и командировочные водителям (${currency})`, propName: "driverSalary", disabled: true },
            { label: `Ремонт и ТО (${currency})`, propName: "repairCost", disabled: true },
            { label: `ОСАГО в месяц по логистам (${currency})`, propName: "osagoByLogist", disabled: true },
            {
                label: `Ответственность груза в месяц по логистам (${currency})`,
                propName: "cargoResponsibilityByLogist",
                disabled: true,
            },
            { label: `Итого лизинг развитие прочее (${currency})`, propName: "totalLease", disabled: true },
            { label: "ИТОГО ЗАТРАТЫ", propName: "totalCost", disabled: true },
            { label: "ВАЛ", propName: "overallPrice", disabled: true },
            { label: "Маржинальность", propName: "marginality", disabled: true },
        ],
    },
    baseValues: {
        isMulti: true,
        cells: [
            { label: `План (${currency}/авто)`, propName: "plan", disabled: false },
            { label: `Оклад (${currency}/авто)`, propName: "salary", disabled: false },
            { label: "Базовые % индивидуальных премий от маржи", propName: "percentageOfMargin", disabled: false },
            { label: "Базовый размер командной премии", propName: "teamPrize", disabled: false },
        ],
    },
    salaries: {
        isMulti: true,
        cells: [
            { label: "Окладная часть", propName: "salary", disabled: true },
            { label: "Индивидуальная премия", propName: "individualPrize", disabled: true },
            { label: "Командная премия", propName: "teamPrize", disabled: true },
            { label: "ИТОГО ЗП с премией", propName: "totalSalaryWithPrize", disabled: true },
        ],
    },
});

export default tableCells;
